import { render } from "./board.html?vue&type=template&id=b75d80d0&external"
import script from "./board.js?vue&type=script&lang=js&external"
export * from "./board.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__